import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getGroupFilterValues as getGroupFilterValuesAPI} from '../../../services/groups'

export async function getGroupFilterValues(
  dispatch,
  {group_id, query = null, limit = null, field_id = null}
) {
  try {
    dispatch({type: PENDING})
    let response = await getGroupFilterValuesAPI({group_id, query, limit, field_id})

    dispatch({type: SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Group Filters Failed: ${group_id}`)
    dispatch({type: FAILURE, payload: e})
  }
}
